import * as React from "react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

// Skeleton animation class
const skeletonPulse = "animate-pulse bg-gradient-to-r from-muted/50 via-muted to-muted/50 bg-[length:200%_100%]";

export const GameCardSkeleton = () => {
  return (
    <Card className="group overflow-hidden rounded-2xl sm:rounded-3xl border-border/60 bg-card/50 shadow-soft">
      <div className="block w-full text-left">
        {/* Image skeleton */}
        <div className="relative">
          <div className={cn("aspect-[4/3] rounded-t-2xl sm:rounded-t-3xl", skeletonPulse)} />
          
          {/* Badge skeletons */}
          <div className="absolute left-3 sm:left-4 top-3 sm:top-4 flex items-center gap-1.5 sm:gap-2">
            <div className={cn("h-5 w-16 rounded-full", skeletonPulse)} />
            <div className={cn("h-5 w-14 rounded-full", skeletonPulse)} />
          </div>
        </div>

        <div className="p-3 sm:p-4">
          {/* Title skeleton */}
          <div className={cn("h-5 w-3/4 rounded", skeletonPulse)} />
          
          {/* Description skeleton */}
          <div className="mt-2 space-y-1.5">
            <div className={cn("h-3 w-full rounded", skeletonPulse)} />
            <div className={cn("h-3 w-2/3 rounded", skeletonPulse)} />
          </div>

          {/* Action buttons skeleton */}
          <div className="mt-3 sm:mt-4 flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 sm:gap-3">
              <div className={cn("h-8 sm:h-9 w-20 rounded-xl sm:rounded-2xl", skeletonPulse)} />
              <div className="flex items-center gap-0.5 sm:gap-1">
                {[1, 2, 3, 4, 5].map((i) => (
                  <div key={i} className={cn("size-4 sm:size-5 rounded", skeletonPulse)} />
                ))}
              </div>
            </div>
            <div className={cn("size-8 sm:size-9 rounded-xl sm:rounded-2xl", skeletonPulse)} />
          </div>
        </div>
      </div>
    </Card>
  );
};

// Grid of skeleton cards
export const GameGridSkeleton = ({ count = 12 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <GameCardSkeleton key={i} />
      ))}
    </>
  );
};
